import { RouteRecordRaw } from 'vue-router'

const Landing: RouteRecordRaw[] = [
  {
    path: '',
    component: () => import('src/layouts/MainLayout.vue'),
    children: [
      {
        path: '/gebraucht-kaufen/wohnmobil/',
        name: 'wohnmobil-landing-page',
        component: () =>
          import('src/apps/landing/pages/WohnmobilLandingPage.vue'),
      },

      {
        path: '/gebraucht-kaufen/campervan/',
        name: 'campervan-landing-page',
        component: () =>
          import('src/apps/landing/pages/CampervanLandingPage.vue'),
      },
      {
        path: '/gebraucht-kaufen/mini-camper/',
        name: 'mini-camper-landing-page',
        component: () =>
          import('src/apps/landing/pages/MiniCamperLandingPage.vue'),
      },

      // Vehicle Type Landing Pages
      // {
      //   path: '/gebraucht-kaufen/kastenwagen/',
      //   name: 'kastenwagen-landing-page',
      //   component: () =>
      //     import('src/apps/landing/pages/KastenwagenLandingPage.vue'),
      // },
      // {
      //   path: '/gebraucht-kaufen/wohnwagen/',
      //   name: 'wohnwagen-landing-page',
      //   component: () =>
      //     import('src/apps/landing/pages/WohnwagenLandingPage.vue'),
      // },
      // {
      //   path: '/gebraucht-kaufen/campingbus/',
      //   name: 'campingbus-landing-page',
      //   component: () =>
      //     import('src/apps/landing/pages/CampingbusLandingPage.vue'),
      // },
      // {
      //   path: '/gebraucht-kaufen/expeditionsmobil/',
      //   name: 'expeditionsmobil-landing-page',
      //   component: () =>
      //     import('src/apps/landing/pages/ExpeditionsmobilLandingPage.vue'),
      // },
      // {
      //   path: '/gebraucht-kaufen/luxus-camper/',
      //   name: 'luxus-camper-landing-page',
      //   component: () =>
      //     import('src/apps/landing/pages/LuxusCamperLandingPage.vue'),
      // },
      // {
      //   path: '/gebraucht-kaufen/familien-camper/',
      //   name: 'familien-camper-landing-page',
      //   component: () =>
      //     import('src/apps/landing/pages/FamilienCamperLandingPage.vue'),
      // },

      // // Brand Landing Pages
      // {
      //   path: '/gebraucht-kaufen/vw-camper/',
      //   name: 'vw-camper-landing-page',
      //   component: () =>
      //     import('src/apps/landing/pages/VWCamperLandingPage.vue'),
      // },
      // {
      //   path: '/gebraucht-kaufen/mercedes-camper/',
      //   name: 'mercedes-camper-landing-page',
      //   component: () =>
      //     import('src/apps/landing/pages/MercedesCamperLandingPage.vue'),
      // },

      // // Price/Segment Landing Pages
      // {
      //   path: '/gebraucht-kaufen/guenstige-camper/',
      //   name: 'guenstige-camper-landing-page',
      //   component: () =>
      //     import('src/apps/landing/pages/GünstigeCamperLandingPage.vue'),
      // },

      // // Location Landing Pages
      // {
      //   path: '/gebraucht-kaufen/berlin-camper/',
      //   name: 'berlin-camper-landing-page',
      //   component: () =>
      //     import('src/apps/landing/pages/BerlinCamperLandingPage.vue'),
      // },
      // {
      //   path: '/gebraucht-kaufen/muenchen-camper/',
      //   name: 'muenchen-camper-landing-page',
      //   component: () =>
      //     import('src/apps/landing/pages/MünchenCamperLandingPage.vue'),
      // },
    ],
  },
]

export default Landing
